module.exports = __webpack_public_path__ + "img/18_81.b055dbe4.png";